import { ref } from 'vue';

const key = ref(0)

export const useUpdateKey = () => {
  const refresh = () => {
    key.value = Date.now()
  }

  return { key, refresh }
}
